import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import { useTourismActions } from '../../context/TourismContext';

Modal.setAppElement('#root'); // Ensure accessibility

function AboutThree() {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [aboutData, setAboutData] = useState(null);
    const [loading, setLoading] = useState(true);
    const { fetchAirbnbAboutSection } = useTourismActions();

    useEffect(() => {
        const loadAboutData = async () => {
            try {
                console.log('Loading Airbnb About Section...');
                const response = await fetchAirbnbAboutSection();
                console.log('About API Response:', response);
                
                // Handle the API response structure
                const data = response?.results?.[0] || response?.[0] || null;
                console.log('Processed about data:', data);
                setAboutData(data);
            } catch (error) {
                console.error('Error loading about section:', error);
                // Keep aboutData as null to use fallback content
            } finally {
                setLoading(false);
            }
        };

        loadAboutData();
    }, [fetchAirbnbAboutSection]);

    // Use dynamic data or fallback to static content
    const content = aboutData || {
        subtitle: "Welcome to Yacht",
        title: "Our goal marine life experiences.",
        description: "There are many variations of passages of available but the majority have suffered alteration in some form, by injected hum randomised words.",
        image1: "/assets/img/normal/about_2_1.jpg",
        image2: "/assets/img/normal/about_2_2.jpg",
        video_url: "https://www.youtube.com/embed/cQfIUPw72Dk",
        feature1_icon: "about_1_1.svg",
        feature1_title: "Exclusive Trip",
        feature1_description: "There are many variations of passages of available but the majority.",
        feature2_icon: "about_1_2.svg",
        feature2_title: "Safety First Always",
        feature2_description: "There are many variations of passages of available but the majority.",
        feature3_icon: "about_1_3.svg",
        feature3_title: "Professional Guide",
        feature3_description: "There are many variations of passages of available but the majority.",
        button_text: "Learn More",
        button_link: "/about"
    };

    console.log('Final content to render:', content);

    return (
        <div className="about-area position-relative overflow-hidden space" id="about-sec">
            <div className="container">
                <div className="row">
                    <div className="col-xl-7">
                        <div className="img-box2">
                            <div className="img1">
                                <img src={content.image1 || "/assets/img/normal/about_2_1.jpg"} alt="About" />
                            </div>
                            <div className="img2">
                                <img src={content.image2 || "/assets/img/normal/about_2_2.jpg"} alt="About" />
                                {content.video_url && (
                                    <button className="play-btn" onClick={() => setModalIsOpen(true)}>
                                        <i className="fa-sharp fa-solid fa-play" />
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5">
                        <div>
                            <div className="title-area mb-20">
                                <span className="sub-title style1">{content.subtitle || "Welcome to Yacht"}</span>
                                <h2 className="sec-title mb-20">{content.title || "Our goal marine life experiences."}</h2>
                            </div>
                            <p className="sec-text mb-30">
                                {content.description || "There are many variations of passages of available but the majority have suffered alteration in some form, by injected hum randomised words."}
                            </p>
                            <div className="about-item-wrap">
                                {[
                                    { 
                                        img: content.feature1_icon || "about_1_1.svg", 
                                        title: content.feature1_title || "Exclusive Trip",
                                        description: content.feature1_description || "There are many variations of passages of available but the majority."
                                    },
                                    { 
                                        img: content.feature2_icon || "about_1_2.svg", 
                                        title: content.feature2_title || "Safety First Always",
                                        description: content.feature2_description || "There are many variations of passages of available but the majority."
                                    },
                                    { 
                                        img: content.feature3_icon || "about_1_3.svg", 
                                        title: content.feature3_title || "Professional Guide",
                                        description: content.feature3_description || "There are many variations of passages of available but the majority."
                                    }
                                ].map((item, index) => (
                                    <div className="about-item style2" key={index}>
                                        <div className="about-item_img">
                                            <img src={`/assets/img/icon/${item.img}`} alt="" />
                                        </div>
                                        <div className="about-item_centent">
                                            <h5 className="box-title">{item.title}</h5>
                                            <p className="about-item_text">
                                                {item.description}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="mt-35">
                                <Link to={content.button_link || "/about"} className="th-btn style3 th-icon">
                                    {content.button_text || "Learn More"}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Video Modal */}
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                contentLabel="Video Popup"
                className="video-modal"
                overlayClassName="video-modal-overlay"
            >
                <button className="close-btn" onClick={() => setModalIsOpen(false)}>&times;</button>
                <iframe
                    width="100%"
                    height="400px"
                    src="https://www.youtube.com/embed/cQfIUPw72Dk"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            </Modal>
        </div>
    );
}

export default AboutThree;